var _rect, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrangeDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.912109,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#FD4319"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.5,
    transform: "matrix(-1 0 0 1 14.4121 6)",
    fill: "#FD4319",
    stroke: "#FD4319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDot);
export default __webpack_public_path__ + "static/media/orange-dot.d4dd9cf82f2244bc5825c7ffdfc5e04f.svg";
export { ForwardRef as ReactComponent };